/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The UserProposal model module.
 * @module model/UserProposal
 * @version 1.0.0
 */
class UserProposal {
    /**
     * Constructs a new <code>UserProposal</code>.
     * @alias module:model/UserProposal
     */
    constructor() { 
        
        UserProposal.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UserProposal</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UserProposal} obj Optional instance to populate.
     * @return {module:model/UserProposal} The populated <code>UserProposal</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UserProposal();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('agent_id')) {
                obj['agent_id'] = ApiClient.convertToType(data['agent_id'], 'Number');
            }
            if (data.hasOwnProperty('user_id')) {
                obj['user_id'] = ApiClient.convertToType(data['user_id'], 'Number');
            }
            if (data.hasOwnProperty('proposal_date')) {
                obj['proposal_date'] = ApiClient.convertToType(data['proposal_date'], 'Date');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('user_registered_at')) {
                obj['user_registered_at'] = ApiClient.convertToType(data['user_registered_at'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UserProposal</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UserProposal</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} id
 */
UserProposal.prototype['id'] = undefined;

/**
 * @member {Number} agent_id
 */
UserProposal.prototype['agent_id'] = undefined;

/**
 * @member {Number} user_id
 */
UserProposal.prototype['user_id'] = undefined;

/**
 * @member {Date} proposal_date
 */
UserProposal.prototype['proposal_date'] = undefined;

/**
 * @member {Date} created_at
 */
UserProposal.prototype['created_at'] = undefined;

/**
 * @member {Date} user_registered_at
 */
UserProposal.prototype['user_registered_at'] = undefined;






export default UserProposal;

